import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card, Spinner, Alert } from "react-bootstrap";
import { FaUser } from "react-icons/fa";
import { UserForm } from "../UserForm";

const API_BASE = "https://18z7zyxvn4.execute-api.us-east-2.amazonaws.com/robovest-api";

const UserProfile = () => {
  const [userData, setUserData]     = useState(null);
  const [isLoading, setIsLoading]   = useState(true);
  const [isSaving, setIsSaving]     = useState(false);
  const [saveStatus, setSaveStatus] = useState(null); // 'success' | 'error'
  const [fetchError, setFetchError] = useState(null);

  const authHeaders = () => ({
    Authorization: "Bearer " + sessionStorage.getItem("jwt"),
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "Application/json",
  });

  useEffect(() => {
    axios
      .get(API_BASE, { headers: authHeaders() })
      .then((res) => {
        setUserData(res.data.user);
        setIsLoading(false);
      })
      .catch((err) => {
        setFetchError("Failed to load profile: " + err.message);
        setIsLoading(false);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = (formData) => {
    setIsSaving(true);
    setSaveStatus(null);
    axios
      .post(API_BASE, { user: { fname: formData.fname, lname: formData.lname } }, { headers: authHeaders() })
      .then(() => {
        setUserData((prev) => ({ ...prev, fname: formData.fname, lname: formData.lname }));
        setSaveStatus("success");
      })
      .catch(() => setSaveStatus("error"))
      .finally(() => setIsSaving(false));
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 300 }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (fetchError) {
    return <Alert variant="danger">{fetchError}</Alert>;
  }

  return (
    <div className="d-flex justify-content-center py-4">
      <Card style={{ width: "100%", maxWidth: 480 }} className="shadow-sm">
        <Card.Header className="d-flex align-items-center gap-2 fw-semibold">
          <FaUser className="text-primary" /> User Profile
        </Card.Header>
        <Card.Body className="p-4">
          {saveStatus === "success" && (
            <Alert variant="success" dismissible onClose={() => setSaveStatus(null)}>
              Profile updated successfully.
            </Alert>
          )}
          {saveStatus === "error" && (
            <Alert variant="danger" dismissible onClose={() => setSaveStatus(null)}>
              Failed to save. Please try again.
            </Alert>
          )}
          <UserForm
            defaultValues={{ fname: userData?.fname ?? "", lname: userData?.lname ?? "" }}
            onSubmit={handleSubmit}
            isSaving={isSaving}
          />
        </Card.Body>
      </Card>
    </div>
  );
};

export default UserProfile;
